
function dateToDateHumanize(value) {
    if (value) {
        var a = new Date(value);
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        var year = a.getFullYear();
        var month = months[a.getMonth()];
        var date = ("0" + a.getDate()).slice(-2);
        var s = date + ' ' + month + ' ' + year;
        return s;
    }
    return ''
}

export default dateToDateHumanize